import { FighterGrid } from '../../../components/FighterGrid';
import { BackBar } from '../../../components/BackBar';
import type { CharacterRow } from '../../../lib/types';

interface FighterStepProps {
  characters: CharacterRow[];
  selectedName: string | null;
  onPickFighter: (name: string) => void;
  onBack: () => void;
}

export function FighterStep({ characters, selectedName, onPickFighter, onBack }: FighterStepProps) {
  return (
    <div className="smash-stage">
      <BackBar onBack={onBack} />
      <div className="smash-banner-wrap">
        <div className="smash-banner">
          <img src="/burst.png" alt="" aria-hidden="true" className="smash-burst" />
          <h1 className="smash-banner__title">Choose Your Fighter</h1>
        </div>
        <div className="smash-silhouette smash-silhouette--question">?</div>
      </div>
      <div className="smash-fighter">
        <FighterGrid
          characters={characters}
          selectedName={selectedName}
          onPickFighter={onPickFighter}
        />
      </div>
    </div>
  );
}
